import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { client, urlFor } from '../client';
import { format } from 'date-fns';

import { Helmet } from 'react-helmet-async';

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('All');

  const CATEGORIES = ['All', 'The Firewall Journal', 'Beyond Tomorrow', 'InfoSphere'];

  useEffect(() => {
    // Fetch all posts from Sanity
    const query = `*[_type == "post"] | order(publishedAt desc) {
      _id,
      title,
      slug,
      mainImage,
      publishedAt,
      "categories": categories[]->title,
      seoTags,
      "authorName": author->name
    }`;

    client.fetch(query)
      .then((data) => {
        setPosts(data);
        setLoading(false);
      })
      .catch((console.error));
  }, []);

  const filteredPosts = activeCategory === 'All' 
    ? posts 
    : posts.filter(post => post.categories && post.categories.includes(activeCategory));

  return (
    <main>
      <Helmet>
        <title>My Blog | Kunal Das</title>
        <meta name="description" content="Technical blogs on cybersecurity, OSINT, and emerging technologies by Kunal Das." />
        <meta property="og:title" content="My Blog | Kunal Das" />
        <meta property="og:description" content="Technical blogs on cybersecurity, OSINT, and emerging technologies by Kunal Das." />
        <meta property="og:url" content="https://kunaldas.tech/blog" />
        <link rel="canonical" href="https://kunaldas.tech/blog" />
      </Helmet>
      <section className="section pb-5 pt-5 mt-5">
        <div className="container">
          <div className="text-center mb-5">
            <h1 className="fw-bold mb-4">My <span className="text-theme">Blogs</span></h1>
            <p className="text-muted">Thoughts, learnings, and technical deep-dives.</p>
          </div>
          
          {/* Category Filter Tabs */}
          <div className="blog-filter-tabs text-center mb-5" data-aos="fade-up" data-aos-duration="1200">
            {CATEGORIES.map(cat => (
              <button 
                key={cat} 
                className={`filter-btn ${activeCategory === cat ? 'active' : ''}`}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="row gy-4">
            {loading ? (
              <div className="col-12 text-center">
                <p className="lead">Loading articles...</p>
              </div>
            ) : filteredPosts.length === 0 ? (
              <div className="col-12 text-center">
                <p className="lead">No articles found in this category.</p>
              </div>
            ) : (
              filteredPosts.map((post, index) => (
                <div className="col-md-4" key={post._id} data-aos="fade-up" data-aos-duration="1200" data-aos-delay={index * 100}>
                  <Link 
                    to={`/blog/${post.slug.current}`} 
                    className="blog-box" 
                  >
                    <div className="blog-box-inner">
                      <div className="blog-img-wrap">
                        {post.mainImage && (
                          <img 
                            src={urlFor(post.mainImage).width(400).height(250).url()} 
                            alt={post.title} 
                            className="img-fluid" 
                          />
                        )}
                      </div>
                      <div className="blog-content-wrap">
                        <h5>{post.title}</h5>
                        <p>{post.publishedAt ? format(new Date(post.publishedAt), 'MMMM dd, yyyy') : ''}</p>
                        <p className="hashtags">
                          {post.categories ? post.categories.map(c => `#${c}`).join(' ') : ''}
                        </p>
                        {post.seoTags && post.seoTags.length > 0 && (
                          <div className="seo-tags mt-2">
                            {post.seoTags.slice(0, 3).map((tag, i) => (
                              <span 
                                key={i} 
                                className="badge me-2 mb-1" 
                                style={{ backgroundColor: 'var(--px-theme)', color: '#fff', fontSize: '11px', fontWeight: '500', padding: '5px 8px' }}
                              >
                                #{tag}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </Link>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </main>
  );
}
